module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('AppGlobalLoader'), _vm._v(" "), _c('AppNotification'), _vm._v(" "), (_vm.isLogged) ? _c('AppHeader') : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('AppSidebar') : _vm._e(), _vm._v(" "), _c('main', {
    staticClass: "main-content",
    class: {
      '-logged': _vm.isLogged, '-loading': _vm.isLoading
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600"
    },
    model: {
      value: (_vm.mostrarModalQuestionarios),
      callback: function($$v) {
        _vm.mostrarModalQuestionarios = $$v
      },
      expression: "mostrarModalQuestionarios"
    }
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('h2', [_vm._v("Questionários de avaliação docente")]), _vm._v(" "), _c('div', {
    staticClass: "subheading",
    staticStyle: {
      "padding": "15px 0"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n            Olá! "), _c('br'), _vm._v(" Por favor, responda o(s) questionário(s) listado(s).\n          ")])]), _vm._v(" "), _vm._l((_vm.questionarios), function(item, index) {
    return [_c('div', {
      staticStyle: {
        "padding": "0 0 15px 0"
      }
    }, [_c('v-btn', {
      attrs: {
        "block": "",
        "color": ("" + (item.obrigatorio ? 'error' : 'success')),
        "large": "",
        "target": "_blank",
        "href": item.url
      }
    }, [_c('i', {
      staticClass: "fas fa-file-alt"
    }), _vm._v(" "), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v(_vm._s(item.obrigatorio ? '* ' : '') + _vm._s(item.nome))])])], 1)]
  }), _vm._v(" "), _c('div', {
    staticClass: "body-1"
  }, [_vm._v("\n          (*) Questionários com asterisco são de preenchimento obrigatório"), _c('br'), _vm._v("\n          Após responder, atualize a página para liberar o acesso.\n        ")])], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (!_vm.possuiQuestionarioObrigatorio) ? _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.mostrarModalQuestionarios = false
      }
    }
  }, [_vm._v("Fechar\n        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('UpdateManagerPopup')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14d81828!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/App.vue
// module id = 524
// module chunks = 2